// extracted by mini-css-extract-plugin
export default {"Pagination-Box":"E7GaIvxEkNoMqiIm6i4z"};